export default __webpack_public_path__ + "static/media/logo-desktop.7335a677.svg";